"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAttachment = exports.validateFile = exports.readFile = void 0;
const react_1 = require("react");
const Attachment_types_1 = require("./Attachment.types");
const readFile = (file) => {
    return new Promise((resolve) => {
        const reader = new FileReader();
        // Read the file via FileReader API and save file result in state.
        reader.onload = function (e) {
            var _a;
            // Add the file name to the data URL
            const dataURL = (_a = e.target) === null || _a === void 0 ? void 0 : _a.result;
            const result = dataURL.replace(";base64", `;name=${file.name};base64`);
            resolve(result);
        };
        reader.readAsDataURL(file);
    });
};
exports.readFile = readFile;
const validateFile = ({ file, maxAllowedFileSize, allowedFileExtensions, }) => {
    const errors = [];
    let isValid = false;
    try {
        if (file.size === 0) {
            errors.push("Cannot upload an empty file");
        }
        if (file.size > maxAllowedFileSize.size) {
            errors.push("File too big, max file size: " +
                maxAllowedFileSize.humanReadable);
        }
        const filename = file === null || file === void 0 ? void 0 : file.name;
        if (filename === undefined || filename === null || filename === "") {
            errors.push("Error with loading filename");
        }
        const fileExtension = filename
            .toString()
            .split(".")
            .pop()
            .toLowerCase();
        if (fileExtension &&
            allowedFileExtensions.indexOf(fileExtension) === -1) {
            errors.push(`Unsupported file extension: File with the extension .${fileExtension} was uploaded, but files can only be one of the supported extensions (${allowedFileExtensions.join(", ")})`);
        }
        isValid = errors.length === 0;
    }
    catch (e) {
        errors.push("Error validating file");
        isValid = false;
    }
    return { isValid, errors };
};
exports.validateFile = validateFile;
const useAttachment = ({ uploadFileFunction, }) => {
    const [status, setStatus] = (0, react_1.useState)(Attachment_types_1.Status.Loading);
    const [attachments, setAttachments] = (0, react_1.useState)([]);
    const onUpload = ({ file, allowedFileExtensions, maxAllowedFileSize, }) => __awaiter(void 0, void 0, void 0, function* () {
        if (!file) {
            return;
        }
        setStatus(Attachment_types_1.Status.Loading);
        const { isValid, errors } = (0, exports.validateFile)({
            file,
            allowedFileExtensions,
            maxAllowedFileSize,
        });
        // Clientside validation
        if (!isValid) {
            setAttachments((prevAttachments) => [
                ...prevAttachments,
                {
                    fileName: file.name,
                    fileSize: file.size,
                    fileType: file.type,
                    errors,
                },
            ]);
            setStatus(Attachment_types_1.Status.Error);
        }
        else {
            // isValid
            const { success, attachmentId } = yield uploadFileFunction({
                file,
            });
            // Serverside validation
            if (!success) {
                setAttachments((prevAttachments) => [
                    ...prevAttachments,
                    {
                        fileName: file.name,
                        fileSize: file.size,
                        fileType: file.type,
                        errors: ["Error uploading file"],
                    },
                ]);
                setStatus(Attachment_types_1.Status.Error);
            }
            else {
                const previewUrl = yield (0, exports.readFile)(file);
                const newAttachment = {
                    attachmentId,
                    fileName: file.name,
                    fileSize: file.size,
                    fileType: file.type,
                    previewUrl,
                    errors: [],
                };
                setAttachments((prevAttachments) => [
                    ...prevAttachments,
                    newAttachment,
                ]);
                setStatus(Attachment_types_1.Status.Success);
            }
        }
    });
    const onRemove = ({ attachmentId }) => {
        setStatus(Attachment_types_1.Status.Loading);
        setAttachments((prevAttachments) => prevAttachments.filter((attachment) => attachment.attachmentId !== attachmentId));
        setStatus(Attachment_types_1.Status.Success);
    };
    return {
        status,
        attachments,
        onUpload,
        onRemove,
    };
};
exports.useAttachment = useAttachment;
//# sourceMappingURL=Attachment.hooks.js.map